"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JoinType = void 0;
var JoinType;
(function (JoinType) {
    JoinType[JoinType["OR"] = 0] = "OR";
    JoinType[JoinType["AND"] = 1] = "AND";
})(JoinType || (exports.JoinType = JoinType = {}));



//////////////////
// WEBPACK FOOTER
// ./~/rules-config/lib/join-type.js
// module id = 1215
// module chunks = 0